import { useRef, useCallback } from 'react'
import { useGetHoveredGameId, useUIActions } from 'src/store/ui'
import { useDeviceInfo } from './useDeviceInfo'

export function useHoveredGame(delay = 120) {
  const uiActions = useUIActions()
  const hoveredGameId = useGetHoveredGameId()
  const { isMobile, isTablet } = useDeviceInfo()

  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const onGameHover = useCallback(
    (gameId: string) => {
      if (isMobile || isTablet) return

      if (debounceRef.current) {
        clearTimeout(debounceRef.current)
      }

      debounceRef.current = setTimeout(() => {
        uiActions.setHoveredGameId(gameId)
      }, delay)
    },
    [delay, isMobile, isTablet, uiActions]
  )

  const onGameLeave = useCallback(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
      debounceRef.current = null
    }
  }, [])

  const onGameTap = useCallback(
    (gameId: string, onNavigate: () => void, preventNavigate = false) => {
      if (hoveredGameId === gameId && !preventNavigate) {
        onNavigate()
      } else {
        uiActions.setHoveredGameId(gameId)
      }
    },
    [hoveredGameId, uiActions]
  )

  return {
    onGameHover,
    onGameLeave,
    onGameTap
  }
}
